import { NdaComponent } from "@/features";

export const NdaPage = () => {
  return <NdaComponent />;
}